import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LocalizedLink } from "../../lib/i18nRouting";
import { formatPrice } from "../../i18n/pricing";
import { FEATURED_IMAGE } from "../../data/experiences";
import Reveal from "../Reveal";

const SLUG = "sunset-panorama-ride";

export default function Featured() {
  const { t, i18n } = useTranslation();
  const price = formatPrice(300, i18n.language, SLUG);

  return (
    <section className="relative bg-forest-deep text-bone overflow-hidden" data-testid="featured-section">
      <div className="absolute inset-0">
        <img src={FEATURED_IMAGE} alt={t(`tours.${SLUG}.name`)} loading="lazy" decoding="async" className="w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-forest-deep via-forest-deep/85 to-transparent" />
        <div className="absolute inset-0 grain" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-32 lg:py-48 grid grid-cols-1 md:grid-cols-12 gap-12">
        <Reveal className="md:col-span-7">
          <div className="text-xs uppercase tracking-wider-3 text-bone/70 mb-6 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-bone/60" />
            {t("featured.eyebrow")}
          </div>
          <h2 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[1.02]">
            {t("featured.title_a")}<br/><span className="italic">{t("featured.title_b")}</span>
          </h2>
          <p className="mt-8 max-w-xl text-bone/80 text-base md:text-lg leading-relaxed">
            {t("featured.body")}
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
            <Stat label={t("common.duration")} value={t("featured.duration")} />
            <Stat label={t("common.price")} value={`${price} ${t("common.per_person")}`} />
            <Stat label={t("common.group")} value={t("featured.group")} />
          </div>

          <LocalizedLink
            to={`/experiente/${SLUG}`}
            data-testid="featured-cta"
            className="btn-lift mt-12 inline-flex items-center gap-3 bg-bone text-forest px-8 py-4 text-xs uppercase tracking-wider-3 hover:bg-bone-deep"
          >
            {t("featured.cta")} <ArrowUpRight className="w-4 h-4" />
          </LocalizedLink>
        </Reveal>
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider-3 text-bone/60">{label}</div>
      <div className="font-display text-2xl mt-2">{value}</div>
    </div>
  );
}
